import { render } from "./vital-sign-chart.vue?vue&type=template&id=0b953c76&scoped=true"
import script from "./vital-sign-chart.vue?vue&type=script&lang=js"
export * from "./vital-sign-chart.vue?vue&type=script&lang=js"

import "./vital-sign-chart.vue?vue&type=style&index=0&id=0b953c76&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b953c76"]])

export default __exports__